
<template>
    <div id="followc" class="wrapperc">
       ID DEMO WORKING SPACE
       <!-- <div class="foo">
            <div class="left">

            </div>
            <div class="right">

            </div>

       </div> -->

      

    
                <!-- <div>Key: {{ key }}, Value: {{ value }}, Index: {{ index }}</div>
                <div v-for="(c, k) in value" :key="k">--- cKey: {{ k }} | cVal: {{ c }}</div> -->
             


        <!-- <div v-for="(value, key, index) in colors.core" :key="key" >
                <div>Key: {{ key }}, Value: {{ value }}, Index: {{ index }}</div>
                <div v-for="(c, k) in value" :key="k">--- cKey: {{ k }} | cVal: {{ c }}</div>
              </div> -->
    </div>

  </template>

  
  <script>
  /* eslint-disable */
 // eslint-disable-next-line no-unused-vars
  import colorJSON from '@/json/colors.json';
  import settingsJSON from '@/json/settings.json';
// import axios from 'axios';
// import Display from './Display.vue';
// import HelperIcons from '@/components/HelperIcons.vue';
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

// import ActiveDemoTic from './ActiveDemoTic.vue';


export default {
  name: 'SettingsDemo',
  components: {
   // ActiveDemoTic
    // Display
    // HelperIcons
    // SvgHelper
    // HelloWorld
  },
  data(){
    return{
        colors: colorJSON,
        settings: settingsJSON

    
      
    }
  },
  mounted() {
  
  },
  unmounted() {

  },
  computed:{
   
    
  },
  methods: {}
    
}
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
    // @import "styles/compass.scss";


.foo {
    height: 100px;
    display: flex;
    gap: 10px;
    .left {background-color: aqua; height: auto; width:100%;}
    .right {background-color: bisque; height: auto;width:100%;}
}


p {user-select: none; }

  .circ {
    width:30px;
    height:30px;
    background-color: red;
    position: fixed;
  }



  </style>
  